import {useTranslation} from 'react-i18next';

import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import {Box, Typography} from '@mui/material';

import {profileComparisonResultCalloutSx} from './profileComparisonSectionStyles';
import {scorePill} from '../../../../../layouts/theme/designSystem';

export const ProfileComparisonRoleMismatchWarning = () => {
  const {t} = useTranslation('translation', {
    keyPrefix: 'workforceDepartmentHealthPage.profileComparison.result.roleMismatch',
  });

  return (
    <Box
      data-testid='profile-comparison-role-mismatch-warning'
      sx={{
        ...profileComparisonResultCalloutSx,
        bgcolor: scorePill.medium.bgcolor,
        color: scorePill.medium.color,
        border: `1px solid ${scorePill.medium.strokeColor}`,
      }}
    >
      <WarningAmberIcon sx={{fontSize: 20, flexShrink: 0, mt: 0.125}} />
      <Box>
        <Typography sx={{fontSize: 13, fontWeight: 600, mb: 0.25, color: 'inherit'}}>{t('title')}</Typography>
        <Typography sx={{fontSize: 12.5, lineHeight: 1.5, color: 'inherit'}}>{t('body')}</Typography>
      </Box>
    </Box>
  );
};
